{
  "removeButtonLabel": "Вилучити",
  "removeDescription": "Натисніть Delete, щоб вилучити тег."
}
